import { useContext } from 'react';
import { BannerContext } from '../contexts/BannerContext'; // Adjust the path as needed

const useBanner = () => useContext(BannerContext);

export default useBanner;
